import { createSelector } from 'reselect';

const selectGlobalBizNetTypes = (state: any) => state.globalBizNetTypes;


export const selectGlobalBizNetTypesCurrentItem = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.current);

export const selectGlobalBizNetTypesListItems = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalBizNetTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalBizNetTypesQueryItems = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.query);

export const selectGlobalBizNetTypesCreatedItem = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.create);

export const selectGlobalBizNetTypesUpdatedItem = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.update);

export const selectGlobalBizNetTypesReadItem = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.read);

export const selectGlobalBizNetTypesDeletedItem = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.delete);

export const selectGlobalBizNetTypesSearchedItems = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.search);

export const selectGlobalBizNetTypesItemsCount = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.count);

export const selectGlobalBizNetTypesItemsFilter = createSelector([selectGlobalBizNetTypes], (globalBizNetTypes) => globalBizNetTypes.filter);